import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import MuiCardHeader from '@mui/material/CardHeader';

interface IProps {
  title?: React.ReactNode;
  subheader?: React.ReactNode;
  action?: React.ReactNode;
  smallTitle?: boolean;
  classes?: any;
  className?: string;
}

const styles = (theme: Theme) => ({
  /** MUI Classes */
  /** Applies to the root element */
  root: {},
  /** Styles applied to the avatar element. */
  avatar: {},
  /** Styles applied to the action element. */
  action: {},
  /** Styles applied to the content wrapper element. */
  content: {},
  /** Styles applied to the title Typography element. */
  title: {
    fontSize: (props: IProps) => (props.smallTitle ? '0.875rem' : '1.5rem'),
    fontWeight: (props: IProps) => (props.smallTitle ? 600 : 400),
    marginBottom: (props: IProps) => (props.smallTitle ? '0.25em' : 'inherit'),
  },
  /** Styles applied to the subheader Typography element. */
  subheader: {},
});

const EDCardHeaderUnstyled: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { smallTitle, ...MuiProps } = props;
  return <MuiCardHeader {...MuiProps} />;
};

export const EDCardHeader = withStyles(EDCardHeaderUnstyled, styles);
